import React, { useContext, useState } from 'react'
import { Link } from 'gatsby'
import CountrySelector from './country-selector'
import AppContext from '../context/app'
import Socials from './socials'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { css } from '@emotion/react'
import { ReactComponent as ArrowRight } from '../images/arrow-right-icon-white.svg'
import Logo from './brand-logo'

const hrStyle = {
    color: 'white',
    borderWidth: 1,
    opacity: .75,
    marginInline: 6,
}

const headingStyle = {
    color: 'white',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '155%',
    padding: 6,
    marginBottom: 0,
}

const linkStyle = {
    color: 'white',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '200%',
    padding: 0,    
    padding: 6,
}

const linkCss = theme => css({
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
        background: theme.colors.primary,
    }
})

const dropdownCss = theme => css({
    padding: 0,
    margin: -6,
    '& > button': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        background: 'transparent',
        border: 0,
        padding: 6,
        fontSize: 'inherit',
        
        '&::after': {
            marginLeft: 'auto',
        },

        '&:hover': {
            background: theme.colors.primary,
        },
        
        '&.btn.show': {
            background: 'transparent',
        }
    },
    '& > div.dropdown-menu-dark': {
        background: 'transparent',
        '& > a:hover': {
            background: theme.colors.primary,
        }
    }
})

export default function HamburgerOffcanvasNav() {
    const { showNav, setShowNav } = useContext(AppContext)
    const [showSupport, setShowSupport] = useState(false)
    const [showCompany, setShowCompany] = useState(false)
    const close = () => setShowNav(false)

    return (
        <Navbar.Offcanvas
            placement="end"
            show={showNav}
            onHide={close}
            style={{
                background: `rgba(0, 0, 0, 0.9)`,
                boxShadow: `0px 0px 100px 100px rgba(0,0,0,.9)`,
            }}
        >
            <Offcanvas.Header
                onHide={close}
                className='justify-content-end align-items-center'
            >
                <Button variant='' onClick={close} className='p-0'>
                    <img src='/svg/x-close-icon-white.svg' alt='' />
                </Button>
            </Offcanvas.Header>
            <Offcanvas.Body
                className='d-flex flex-column justify-content-between'
                style={{
                    paddingInline: 16,
                    paddingTop: 0,
                    paddingBottom: 120,
                }}
            >
                <Nav>
                    <p style={headingStyle}>SOFTWARE</p>
                    <Nav.Link
                        as={Link}
                        to='/bfd-player'
                        style={linkStyle}
                        css={linkCss}
                    >
                        BFD PLAYER
                        <ArrowRight />
                    </Nav.Link>
                    <Nav.Link
                        as={Link}
                        to='/bfd3'
                        style={linkStyle}
                        css={linkCss}
                    >
                        BFD3
                        <ArrowRight />
                    </Nav.Link>
                    <hr style={hrStyle} />
                    
                    <p style={headingStyle}>EXPANSIONS</p>
                    <Nav.Link
                        as={Link}
                        to='/bfd-player-expansions'
                        style={linkStyle}
                        css={linkCss}
                    >
                        BFD PLAYER EXPANSIONS
                        <ArrowRight />
                    </Nav.Link>
                    <Nav.Link
                        as={Link}
                        to='/bfd3-expansions'
                        style={linkStyle}
                        css={linkCss}
                    >
                        BFD3 EXPANSIONS
                        <ArrowRight />
                    </Nav.Link>
                    <Nav.Link
                        as={Link}
                        to='/bfd3-groove-packs'
                        style={linkStyle}
                        css={linkCss}
                    >
                        BFD3 GROOVE PACKS
                        <ArrowRight />
                    </Nav.Link>
                    <hr style={hrStyle} />

                    <DropdownButton
                        id='dropdown-support'
                        title='SUPPORT'
                        variant='dark'
                        menuVariant='dark'
                        style={headingStyle}
                        css={dropdownCss}
                    >
                        <Dropdown.Item
                            href="https://forum.bfddrums.com/"
                            rel='noreferrer'
                            target='_blank'
                            style={linkStyle}
                            css={linkCss}
                        >
                            FORUM
                            <ArrowRight />
                        </Dropdown.Item>
                        <Dropdown.Item
                            to="/downloads"
                            as={Link}
                            style={linkStyle}
                            css={linkCss}
                        >
                            DOWNLOADS
                            <ArrowRight />
                        </Dropdown.Item>
                        <Dropdown.Item
                            href='https://support.bfddrums.com/en/support/home'
                            rel='noreferrer'
                            target='_blank'
                            style={linkStyle}
                            css={linkCss}
                        >
                            KNOWLEDGE BASE
                            <ArrowRight />
                        </Dropdown.Item>
                        <Dropdown.Item
                            href='https://support.bfddrums.com/en/support/home'
                            rel='noreferrer'
                            target='_blank'
                            style={linkStyle}
                            css={linkCss}
                        >
                            CONTACT SUPPORT
                            <ArrowRight />
                        </Dropdown.Item>
                    </DropdownButton>
                    <hr style={hrStyle} />

                    <DropdownButton
                        id='dropdown-company'
                        title='COMPANY'
                        variant='dark'
                        menuVariant='dark'
                        style={headingStyle}
                        css={dropdownCss}
                    >
                        <Dropdown.Item
                            to='/about-us'
                            as={Link}
                            style={linkStyle}
                            css={linkCss}
                        >
                            ABOUT US
                            <ArrowRight />
                        </Dropdown.Item>
                        <Dropdown.Item
                            href='https://www.inmusicbrands.com/careers/'
                            rel='noreferrer'
                            target='_blank'
                            style={linkStyle}
                            css={linkCss}
                        >
                            CAREERS
                            <ArrowRight />
                        </Dropdown.Item>
                    </DropdownButton>
                    <hr style={hrStyle} />

                    <a
                        href="https://profile.inmusicbrands.com/"
                        target="_blank"
                        rel='noreferrer'
                        style={headingStyle}
                        css={linkCss}
                    >
                        ACCOUNT
                        <img src='/svg/new-tab-icon-white.svg' alt='' />
                    </a>
                    <hr style={hrStyle} />
                    
                    <CountrySelector
                        style={headingStyle}
                        css={dropdownCss}
                    />
                </Nav>
                
                {/* BOTTOM RIGHT */}
                <div
                    className='d-flex flex-column align-items-end'
                    style={{ paddingInline: 6, gap: 20 }}
                >
                    <Logo />
                    <Socials
                        keyHelper='offcanvas'
                        className='justify-content-end'
                    />
                </div>
            </Offcanvas.Body>
        </Navbar.Offcanvas>
    )
}
